// import { Granularity } from "@/API";
import { Stat } from "@/entities";
import { IAllSaleStatRepository } from "@/repositories";
import dayjs from "dayjs";
import { IAllSaleStatService } from ".";

export class AllSaleStatService implements IAllSaleStatService {
    constructor(private repository: IAllSaleStatRepository) { }
    async listDailyStat(inputDate: Date): Promise<Stat[] | undefined> {
        let list: Stat[] = [];
        if (!inputDate) {
            throw new Error("No inputDate parameter.");
        }

        const input = dayjs(inputDate)


        let temp: Stat[] = [];
        let token: string | undefined;
        do {
            const { items, nextToken } = await this.repository.getAllSaleStat("DAILY", { eq: input.unix() }, token)
            // console.log(items, nextToken);
            if (items) {
                const l = items.map((i: any) => new Stat(i));
                temp = [...temp, ...l];
            }
            token = nextToken;
        }
        while (token);
        list = [...list, ...temp];
        list = list.filter((l) => {
            if (l.id && l.id.length > 5) {
                return true
            }
            return false
        })
        console.log("listDailyStat", list)
        return list;
    }
    async listWeeklyStat(inputWeek: Date): Promise<Stat[] | undefined> {
        let list: Stat[] = [];
        if (!inputWeek) {
            throw new Error("No inputWeek parameter.");
        }

        const input = dayjs(inputWeek).startOf("week");

        console.log(input.format())

        let temp: Stat[] = [];
        let token: string | undefined;
        do {
            const { items, nextToken } = await this.repository.getAllSaleStat("WEEKLY", { eq: input.unix() }, token)
            // console.log(items, nextToken);
            if (items) {
                const l = items.map((i: any) => new Stat(i));
                temp = [...temp, ...l];
            }
            token = nextToken;
        }
        while (token);
        list = [...list, ...temp];
        list = list.filter((l) => {
            if (l.id && l.id.length > 5) {
                return true
            }
            return false
        })
        console.log("listWeeklyStat", list)
        return list;
    }
    async listMonthlyStat(inputMonth: Date): Promise<Stat[] | undefined> {
        let list: Stat[] = [];
        if (!inputMonth) {
            throw new Error("No inputWeek parameter.");
        }

        const input = dayjs(inputMonth)


        let temp: Stat[] = [];
        let token: string | undefined;
        do {
            const { items, nextToken } = await this.repository.getAllSaleStat("MONTHLY", { eq: input.unix() }, token)
            // console.log(items, nextToken);
            if (items) {
                const l = items.map((i: any) => new Stat(i));
                temp = [...temp, ...l];
            }
            token = nextToken;
        }
        while (token);
        list = [...list, ...temp];
        list = list.filter((l) => {
            if (l.id && l.id.length > 5) {
                return true
            }
            return false
        })
        console.log("listMonthlyStat", list)
        return list;
    }
    async refrehsDailyStat(): Promise<void> {
        return this.repository.refreshDailyStat();
    }
    async exportCSV(): Promise<string> {
        return ""
    }
}